/**
 * External dependencies
 */
import React from "react";
import { Location } from "@reach/router";

/**
 * Internal dependencies
 */
import { getFromQueryString } from "../utilities";

export default function CountdownBanner(props) {
  return (
    <Location>
      {({ location }) => {
        const query = getFromQueryString(location.search, "mi_promo");
        if (query) {
          return (
            <div
              style={{
                width: "100%",
                backgroundColor: "#febd32",
                textAlign: "center"
              }}
            >
              <img
                alt="Your SPRING20 promo code has been applied to your cart!"
                style={{
                  border: 0,
                  width: "auto",
                  height: "auto"
                }}
                border="0"
                src="https://tyacfemb.mi-content.com/p/rp/68cbf7bb580083b9.png"
              />
            </div>
          );
        }
        return null;
      }}
    </Location>
  );
}
